exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-body[data-v-067fb2b4] table > tbody > tr > td {\n\tcursor: pointer;\n}\n", ""]);

// exports
